export default __webpack_public_path__ + "static/nyu-0fb08f604a8d635b836672c52cd30fc8.png";